import * as React from 'react'
import type * as Dialog from 'primitives/dialog'

import { clientSecrets } from '../lib/client-secrets'

type RootProps = React.ComponentProps<typeof Dialog.Root>

let isAutoOpenedDialogDismissed = false

function hasAutoOpenClientSecrets() {
  return Boolean(
    clientSecrets.paymentIntentClientSecret ||
    clientSecrets.setupIntentClientSecret ||
    clientSecrets.isFreeTrialAutostartSuccess ||
    clientSecrets.isSubscriptionAutostartSuccess,
  )
}

export function usePaymentsCompleteScreenDialog() {
  const isAutoOpenFlow = hasAutoOpenClientSecrets()
  const [open, setOpen] = React.useState(() => isAutoOpenFlow && !isAutoOpenedDialogDismissed)

  return {
    getRootProps(props?: RootProps) {
      const { open: controlledOpen, onOpenChange, ...rest } = props ?? {}

      return {
        ...rest,
        open: controlledOpen ?? open,
        onOpenChange: (nextOpen: boolean) => {
          onOpenChange?.(nextOpen)

          if (isAutoOpenFlow && !nextOpen) {
            isAutoOpenedDialogDismissed = true
          }

          if (controlledOpen === undefined) {
            if (isAutoOpenFlow && nextOpen && isAutoOpenedDialogDismissed) {
              return
            }

            setOpen(nextOpen)
          }
        },
      }
    },
  }
}
